import { useMemo } from 'react';
import styles from './PlanCardTitle.module.scss';
import { PlanKind } from 'src/types';
import { PLAN_KIND_TITLE_MAP_V2 } from 'src/constants';

export interface PlanCardTitleV2Props {
  planKind: PlanKind;
}

export const PlanCardTitle = ({ planKind }: PlanCardTitleV2Props) => {
  const displayName = useMemo(() => {
    return PLAN_KIND_TITLE_MAP_V2[planKind]?.fullTitle || '';
  }, [planKind]);

  return (
    <div>
      <h5 className={styles.title}>{displayName}</h5>
      {/*todo temporary hide it*/}
      {/*<p className={styles.subtitle}>*/}
      {/*  {PLAN_KIND_TITLE_MAP_V2[planKind]?.description}*/}
      {/*</p>*/}
    </div>
  );
};
